<template>
<div>
<v-layout fluid style="width: 100%;" class="pa-0 d-flex flex-row" lights-out>
	<v-row class="ma-0">
    <v-col cols="12" sm="12" lg="3"  :style="{'background-color': color}">
        <v-row>
			<v-col cols="auto">
				<slot name="breadcrumbs" :item="true"></slot>
			</v-col>
			<v-spacer/>
			<!-- export -->
			<v-col cols="auto">
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn dark color="printingColor" class="px-2" v-on="on">
							<span class="d-flex align-center">
								<v-icon color="white">mdi-export-variant</v-icon>
								<span style="font-size: 14px">
									{{$t('AccountsTreePage.export')}}
								</span>
							</span>
						</v-btn>
					</template>

					<bee-list>
						<!-- excel -->
						<bee-list-item
							context="tree"
							:item="exportItems[0]"
							dense
							@click="exportAs('excel')"
						></bee-list-item>

						<!-- pdf -->
						<bee-list-item
							context="tree"
							:item="exportItems[1]"
							dense
							@click="exportAs('pdf')"
						></bee-list-item>
					</bee-list>
				</v-menu>
			</v-col>
		</v-row>
		<v-row fill-height>
			<v-main style="width: 100%" class="px-3 pt-0" color="greyLighten5">
				<bee-treeview
					v-if="renderComponent"
					@update:active="showProfile($event)"
					:filter-hint="$t('AccountsTreePage.account-num-or-name')"
					:lables-values="['accounting_no', 'name']"
					:items="accounts_tree"
					show-context-menu
					:contextmenu-items="[
						{ title: $t('buttons.add-child'), event: 'add-child', disabled: item => item.type === 2 },
						{ title: $t('buttons.account-statement'), event: 'account-statement' },
						{ title: $t('buttons.edit'), event: 'edit' },
						{ title: $t('buttons.delete'), event: 'delete' },
					]"
					@context-menu-add-child="(item) => {
						node = {...item};
						selected = true;
						$route.params.parentId !== item.id
							? $router.push({ name: 'add-account', params: { parentId: item.id } })
							: null
					}"
					@context-menu-account-statement="item => $router.push({ name: 'statement', params: { id: item.id } })"
					@context-menu-edit="showProfile($event, true)"
					@context-menu-delete="showProfile($event, false, true)"
				>
					<template v-slot:actions="{}">
                        <bee-btn
						@click="createAccount()"
						:disabled="file_is_locked"
						color="addingColor"
						:content="$t('AccountsTreePage.add')"
						icon="fa-user-plus"
						context="account"
						:action-name="actions.CREATE"
						v-if="$route.name != 'edit-account'"
						></bee-btn>
                    </template>
				</bee-treeview>
			</v-main>
		</v-row>
    </v-col>

    <v-col cols="auto" sm="12" lg="9">
		<v-scroll-y-transition mode="out-in">
			<v-card flat style="height: 80vh" v-if="!selected" class="d-flex flex-column justify-content-center justify-center">
			<v-card-text>
			<v-img
					left
					class="shrink"
					contain
					:src="require('../../../assets/selectUser.png')"
					transition="scale-transition"
					height="200"
				/>
			</v-card-text>
			<v-card-title class="align-center justify-center">
				<span style="align-self: center;" class="blue-grey--text text--lighten-1 font-weight-light">
					{{$t('AccountsTreePage.please-select-account')}}
				</span>
			</v-card-title>
			</v-card>
			
			<router-view v-else></router-view>
		</v-scroll-y-transition>
	</v-col>
	</v-row>
</v-layout>
<v-bottom-navigation
	app
    class="px-3"
    horizontal
    background-color="greyLighten3">
    <v-row align="center" justify="center">
        <bee-outlined-header-info :head="$t('AccountsTreePage.number-of-main-accounts')" empty-state="_" :content="configs? configs.num_of_primary_accounts : null">
        </bee-outlined-header-info>
        <bee-outlined-header-info :head="$t('AccountsTreePage.number-of-sub-accounts')" empty-state="_" :content="configs? configs.num_of_secondary_accounts : null">
        </bee-outlined-header-info>
    </v-row>
</v-bottom-navigation>
</div>
</template>
<script>
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
import EventBus from '../../../event-bus';
import actions from "../../../permissions/actions-names.js"
import ls from '../../../settings/localStorageExtension';
export default {
data: () => ({
	actions,
	renderComponent:true,
    selected: false,
	items:[],
	node: {id: null}
  }),
methods: {
    showProfile(item, isEdit = false, isDelete = false) {
		this.selected = true
		if(item)
		{
			const route = {
				name: !isEdit ? 'account' : 'edit-account',
				params: { id: item.id },
			}
			if (isDelete) {
				route.query = { isDelete: true }
			}
			this.$router.push(route).catch(() => {})
			this.node = {...item}
			store.dispatch("statements/fetchAccountStatementSummary", { accountId: item.id })
		}
		else{
			this.$router.push({ name: "accounts-tree"}).catch(()=>{})
			this.node = null
		}	
	},
	createAccount() {
		this.node?.id  && this.selected
			? this.$router.push({ name: "add-account", params: { parentId: this.node.id } }).catch(()=>{}) 
			: this.$router.push({ name: "create-account" }).catch(()=>{})
		},
	forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;

        setTimeout(() => {
          // Add the component back in
          this.renderComponent = true;
        }, 2000);
	},
	exportAs(type) {
        this.$store.dispatch('reports/AccountsTreeReport', {
            type,
            financialFileId: this.configs.financial_file.id,
			userId: ls.getLocalUser().id,
        })
    }
},
computed: {
	...mapState("configs", ["configs"]),
	...mapState( "accounts" , ["accounts_tree"] ),
	exportItems() {
		return [
			{
				text: this.$t('AccountsTreePage.export-as-excel'),
				icon: 'mdi-microsoft-excel',
				context: 'tree',
				action_name: actions.EXPORT_AS_PDF
			},
			{
				text: this.$t('AccountsTreePage.print-accounts-tree'),
				icon: 'mdi-printer',
				context: 'tree',
				action_name: actions.EXPORT_AS_PDF
			},
		]
	},
	color() {
      return this.$vuetify.theme.themes.light.greyLighten5;
	},
	show_action_bar(){
		return (this.$route.name == "accounts-tree") || (this.$route.name == "account")
	},
	file_is_locked(){
        return this.configs?.financial_file?.is_locked }
},
watch: {
	$route: function () {
		(this.$route.name == "accounts-tree")  ? this.selected = false : this.selected = true
	}
},
mounted(){
	EventBus.$on('reload-accounts-tree', ()=>{ this.forceRerender()});
},
async beforeRouteEnter(to, from, next) {

	let promises = [store.dispatch("accounts/fetchTree")]
		

	let custom_statements = JSON.parse(JSON.stringify(store.state.customStatements.custom_statements))
	if(Object.keys(custom_statements).length == 0)
		promises.push(store.dispatch("customStatements/fetchAll"))

	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch('configs/fetchAll'))

	await Promise.all(promises)

    next(vm => {
		to.name == "accounts-tree" ? vm.selected = false : vm.selected = true
    })
},
meta: {
		title: 'accounts-tree',
		meta: [
			{property: 'og:title', content: 'accounts-tree / mirta'},
		],
	},
};
</script>
<style lang="scss" scoped>
.v-btn--outlined{
    border: solid #608391 !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
	margin-right: 60px !important;
	align-items: center !important;
    display: flex !important;
    justify-content: center !important;
}
.v-bottom-navigation {
  overflow-y: unset;
}
@media screen and (max-width: 480px) {
.v-bottom-navigation {
  overflow-y: scroll !important;
}
}
</style>
<style>
.fixed {
  position: static;
}
</style>